import { render, staticRenderFns } from "./work_item_relationships.vue.js?vue&type=template&id=2fef1cea!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_relationships.vue?vue&type=template&id=2fef1cea"
import script from "./work_item_relationships.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_relationships.vue?vue&type=script&lang=js"
export * from "./work_item_relationships.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_relationships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports